if (typeof ComparisionColumns !== 'function') {
    class ComparisionColumns extends HTMLElement {
        constructor() {
            super();

            this.buttonHandleTooltip = this.querySelectorAll('[data-button-handle-tooltip]');
            this.buttonDismiss = this.querySelectorAll('[data-modal-dismiss]');
            this.optionButtons = this.querySelectorAll('[data-addons-product]');

            if (this.buttonHandleTooltip) {
                this.buttonHandleTooltip.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const target = button.getAttribute('data-tooltip-target');
                        this.querySelector(`#${target}`).classList.add('show');
                    })
                })
            }

            if (this.buttonDismiss) {
                this.buttonDismiss.forEach(button => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const target = button.getAttribute('data-tooltip-target');
                        this.querySelector(`#${target}`).classList.remove('show');
                    })
                })
            }
        }
    }

    if (typeof customElements.get('comparision-columns') == 'undefined') {
        customElements.define('comparision-columns', ComparisionColumns);
    }
}

$(document).ready(function () {
    if(screen.width < 1200) {
        document.querySelector('#compare_items_holder').classList.add('swiper');
        document.querySelector('.compare_swipper').classList.add('swiper-wrapper');
        document.querySelectorAll('.compare_item').forEach(ele => {
            ele.classList.add('swiper-slide');
        })
        const swiper = new Swiper('#compare_items_holder', {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            dots: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            }
          });
        
    }
    
  });